module.exports = __webpack_public_path__ + "img/downloadBlue.0f91a68b.svg";